import { hasValue } from '~/utils/common'

/**
 * Attempts to convert a number to a locale string with a minimum number of digits.
 * @param value The number to convert.
 * @param length The minimum number of digits to display. Default is 2.
 * @returns The locale string representation of the number, or undefined if the value is undefined.
 */
export const tryGetLocaleNumericString = (value?: number, length = 2) => {
  if (!hasValue(value)) {
    return undefined
  }

  return value?.toLocaleString('en-US', {
    minimumIntegerDigits: length,
    useGrouping: false,
  })
}
